module.exports = __webpack_public_path__ + "static/media/dressMain.4797655c.png";